import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    // Initialize age verification after drawer opens
    setTimeout(() => {
      this.#initAgeVerification();
    }, 100);

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  #initAgeVerification() {
    const checkbox = document.getElementById('age-verification-checkbox');
    const checkoutButton = document.getElementById('checkout');
    const additionalCheckoutButtons = document.getElementById('additional-checkout-buttons-container');
    
    if (!checkbox || !checkoutButton) return;

    // Remove existing event listeners to avoid duplicates
    const newCheckbox = checkbox.cloneNode(true);
    checkbox.parentNode.replaceChild(newCheckbox, checkbox);

    // Function to update button states
    const updateCheckoutButtons = () => {
      const isChecked = newCheckbox.checked;
      const isCartEmpty = checkoutButton.hasAttribute('disabled') && 
                          checkoutButton.getAttribute('disabled') === 'disabled';
      
      // Enable/disable main checkout button
      if (isCartEmpty) {
        checkoutButton.disabled = true;
      } else {
        checkoutButton.disabled = !isChecked;
      }

      // Show/hide additional checkout buttons
      if (additionalCheckoutButtons) {
        additionalCheckoutButtons.style.display = isChecked ? 'block' : 'none';
      }
    };

    // Listen for checkbox changes
    newCheckbox.addEventListener('change', updateCheckoutButtons);

    // Initial state
    updateCheckoutButtons();

    // Prevent form submission if not checked
    const cartForm = document.getElementById('cart-form');
    if (cartForm) {
      const handleSubmit = (e) => {
        if (!newCheckbox.checked) {
          e.preventDefault();
          alert('Please confirm that you are 21+ and agree to the Terms & Conditions.');
          newCheckbox.focus();
        }
      };
      
      // Remove old listener if exists
      cartForm.removeEventListener('submit', handleSubmit);
      cartForm.addEventListener('submit', handleSubmit);
    }
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}